import React from 'react';
import { Link } from 'react-router-dom';

const GeometryToggleCard = ({ currentTab, queryStringParse }) => {
    const { jurisdiction } = queryStringParse();
    const selectedGeometry = jurisdiction || 'primary';

    return (
        <div className="toggleCard">
            {currentTab.mapSettings.mapSets.map((layerSet) => {
                const { geometry } = layerSet;
                const { set } = layerSet;
                return (
                    <div
                        key={set}
                        role="presentation"
                        className="toggle-option"
                    >
                        <Link
                            to={`?jurisdiction=${set}`}
                            className="toggle-card-links"
                        >
                            <span
                                className={`toggle-icon ${
                                    selectedGeometry === set
                                        ? 'toggle-selected'
                                        : ''
                                }`}
                            ></span>

                            {geometry}
                        </Link>
                    </div>
                );
            })}
        </div>
    );
};

export default GeometryToggleCard;
